<template>
  <div
    ref="moreMenu"
    class="ah-more-nav"
    @keydown="keydownHandler"
  >
    <AhMenuItem
      :id="id"
      ref="moreButton"
      :tracking="tracking"
      :aria-expanded="isOpenTab ? 'true' : 'false'"
      :aria-controls="ariaControls"
      :active="isOpenTab"
      variation="more"
      @clicked="toggleTabMore"
    >
      <template #label>
        <span class="ah-menu-item__label">{{ label }}</span>
      </template>
    </AhMenuItem>
    <Transition
      :name="effect"
    >
      <AhNavTabs
        v-if="isOpenTab"
        :id="ariaControls"
        ref="navTabs"
        :aria-labelledby="id"
        :list-items="listItems"
        @tabs-nav-item-click="tabItemsClickHandler"
      />
    </Transition>
  </div>
</template>
<script>
  import AhMenuItem from '../../molecules/AhMenuItem/AhMenuItem.vue';
  import AhNavTabs from '../AhNavTabs/AhNavTabs.vue';
  import { MORE_BUTTONS_LABELS } from '../../../constants/wording.js';
  export default {
    components: {
      AhNavTabs,
      AhMenuItem,
    },
    inject: {
      $lang: {
        default: () => function() { return 'en'; },
      }
    },
    props: {
      listItems: {
        type: Array,
        default: () => [],
      },
      effect: {
        type: String,
        default: 'ah-fade',
      },
      id: {
        type: String,
        default: 'more-item-nav',
      },
      tracking: {
        type: String,
        default: 'more',
      },
      ariaControls: {
        type: String,
        default: 'tab-panel-more',
      },
      text: {
        type: [String, null],
        default: null,
      },
    },
    data() {
      return {
        isOpenTab: false,
      };
    },
    computed: {
      label() {
        return this.text || MORE_BUTTONS_LABELS[this.lang];
      },
      lang() {
        return this.$lang();
      }
    },
    mounted() {
      document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
      handleClickOutside(event) {
        if (!this.$refs?.moreMenu?.contains(event.target) && this.isOpenTab) {
          this.close();
        }
      },
      toggleTabMore() {
        this.isOpenTab = !this.isOpenTab;
        this.$emit(
          'open-more-nav',
          {
            id: this.id,
            text: this.label,
            tracking: this.tracking,
            opened: this.isOpenTab
          }
        );
      },
      close() {
        this.$emit(
          'open-more-nav:close',
          {
            id: this.id,
            text: this.label,
            tracking: this.tracking,
          }
        );
        this.isOpenTab = false;
      },
      keydownHandler(e) {
        if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
          this.$emit(
            'open-more-nav:close',
            {
              id: this.id,
              text: this.label,
              tracking: this.tracking,
            }
          );
          this.isOpenTab = false;
          this.$refs.moreButton.$el.focus();
          e.preventDefault();
        }
        if (e.key && e.key === 'Tab') {
          if(!this.isOpenTab) return;
          const activeElementId = document.activeElement.id || null;
          const tabListChildren = Array.prototype.slice.call( this.$refs.navTabs.$refs.tabList.children);
          const tabListChildrenLink = tabListChildren.filter(element => element.tagName === 'A');
          const tabPanelElementsLinks =  this.$refs.navTabs.$el.querySelectorAll('a');
          const firstTabLinkElement = tabListChildrenLink.length ? tabListChildrenLink[0].id : null;
          if(tabListChildren.indexOf(e.target) !== -1 && e.shiftKey) {
            this.$refs.moreButton.$el.focus();
            this.close();
            e.preventDefault();
          }
          if(
            (firstTabLinkElement === activeElementId && !e.shiftKey)
            ||
            (activeElementId ===  tabPanelElementsLinks[tabPanelElementsLinks.length - 1].id && !e.shiftKey)
          ) {
            this.close();
          }
        }
      },
      tabItemsClickHandler(data) {
        this.$emit('tabs-nav-item-click', {parent:'more', ...data});
      }
    }
  };
</script>
